exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lookupsComponent .search-inputs[data-v-4d76f8e2]{width:300px}\n", ""]);

